import { HttpInterceptorFn } from '@angular/common/http';
import { throwError, timeout } from 'rxjs';

export function withRequestTimeout(
  defaultMs: number,
  rules: Record<string, number> = {},
): HttpInterceptorFn {
  return (req, next) => {
    const matchedRule = Object.keys(rules).find((pattern) =>
      new RegExp(pattern.replace('*', '.*')).test(req.url),
    );
    const limit = matchedRule ? rules[matchedRule] : defaultMs;
    return next(req).pipe(
      timeout({
        each: limit,
        with: () => throwError(() => new Error(`Request timed out after ${limit} ms`)),
      }),
    );
  };
}
